
    import { createSlice, PayloadAction } from '@reduxjs/toolkit'
    
    type THelpState =  {
        data: [],
        perPage: number,
        currentPage: number,
        totalPage: number,
        searchTerm: string,
        helploading: boolean,
        sortBy: string,
        sortColumn:string,
    }
    
    
    const initialHelpState: THelpState = {
        data: [],
        perPage: 10,
        currentPage: 1,
        totalPage: 5,
        searchTerm: "",
        helploading: false,
        sortBy: "desc",
        sortColumn:""
    
        
    }
    
    export const helpSlice = createSlice({
        name: 'help',
        initialState:initialHelpState,
        reducers: {
            setHelp: (state:THelpState, { payload }: PayloadAction<[]>) => {
              state.data=payload
             },
            setPerPage: (state:THelpState, {payload}: PayloadAction<number>) => {
                state.perPage = payload;
            },
            setCurrentPage: (state:THelpState, {payload}: PayloadAction<number>) => { 
                state.currentPage = payload;
            },
            setTotalPage: (state:THelpState, {payload}: PayloadAction<number>) => { },
            setSearchTerm: (state:THelpState, {payload}: PayloadAction<string>) => { 
                state.searchTerm = payload;
            },
            setSortBy: (state:THelpState, {payload}: PayloadAction<string>) => { 
              state.sortBy = payload;
          },
          setSortColumn: (state:THelpState, {payload}: PayloadAction<string>) => { 
            state.sortColumn = payload;
            state.sortBy = "desc";
        },
            setLoading: (state:THelpState, {payload}: PayloadAction<boolean>) => { 
              state.helploading = payload
            },
        },
    })
    
    
    export const { setHelp, setPerPage, setCurrentPage, setSortColumn,setSortBy, setTotalPage, setSearchTerm, setLoading } = helpSlice.actions
    export default helpSlice.reducer
    